import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Table } from 'react-bootstrap';

import { get } from 'helpers/api';

import { VouchersTable } from 'bundles/backoffice/vouchers/index/table';
import LoadingSpinner from 'components/loading_spinner';

import CreateButton from './create_button';
import CreateModal from './create_modal';

import './styles.scss';
import { groupBy } from 'lodash';

const suiteLabelsByType = {
  CondoListing: 'Condo',
  LotListing: 'Lot',
};

export class VouchersTab extends React.Component {
  static propTypes = {
    proposal: PropTypes.bool,
    showForAssignment: PropTypes.bool,
    vouchersSearchPath: PropTypes.string.isRequired,
  }

  state = {}

  componentDidMount() {
    get(this.props.vouchersSearchPath)
      .then((data) => {
        this.setState({
          vouchers: data.vouchers,
        });
      });
  }

  totals = (vouchers) => {
    return {
      grossCommissionAmount: vouchers.reduce((sum, { grossCommissionAmount }) => sum + grossCommissionAmount, 0),
      transactionValue: vouchers.reduce((sum, { transactionValue }) => sum + transactionValue, 0),
    };
  }

  handleNewVoucher = (voucher) => {
    this.setState((state) => {
      return {
        vouchers: [
          ...state.vouchers,
          voucher
        ]
      };
    });
  }

  handleCreateButtonClick = (listings) => {
    this.setState({ listings });
  };

  render() {
    const { listings, pendingRequest } = this.state;

    return (
      <React.Fragment>
        <div>
          <h2 className="pull-left">Vouchers</h2>
          <div className="pull-right">
            <CreateButton
              disabled={pendingRequest}
              proposal={this.props.proposal}
              showForAssignment={this.props.showForAssignment}
              onClick={this.handleCreateButtonClick}
            />
            <CreateModal
              listings={listings}
              show={listings != null}
              onCancel={() => this.setState({ listings: null })}
              onNewVoucher={this.handleNewVoucher}
            />
          </div>
        </div>
        <div className="clearfix" />
        <hr className="mt-0" />
        {this.renderContent()}
      </React.Fragment>
    );
  }

  renderContent() {
    const hasVouchers = this.state.vouchers && this.state.vouchers.length !== 0;

    if (this.state.vouchers) {
      return (
        <div className={classnames({ 'empty-search-results': !hasVouchers })}>
          {this.renderTables()}
        </div>
      );
    } else {
      return <LoadingSpinner />;
    }
  }

  renderTables() {
    if (this.state.vouchers.length === 0) {
      return (
        <Table>
          <tbody>
            <tr>
              <td className="text-center">
                No vouchers have been created for this property
              </td>
            </tr>
          </tbody>
        </Table>
      );
    }

    const groupedVouchers = groupBy(this.state.vouchers, 'listing.typeLabel');

    const typeLabels = Object.keys(groupedVouchers)
      .sort()
      .reverse();

    return typeLabels.map((label) => {
      const vouchers = groupedVouchers[label];

      return (
        <React.Fragment key={label}>
          <h3>{label} Vouchers</h3>
          <Table className="bo-search-results bordered">
            <VouchersTable
              minimal
              totals={this.totals(vouchers)}
              vouchers={vouchers}
            />
          </Table>
        </React.Fragment>
      );
    });
  }
}

export default VouchersTab;
